const buildUserSession = (cognitoSession, attributes) => {
  const { payload } = cognitoSession.idToken;
  const companyItems = attributes
    .filter((attr) => attr.Name === "custom:company")
    .map((attr) => attr.Value);
  return {
    instance: cognitoSession,
    authTime: new Date(1000 * payload.auth_time),
    expTime: new Date(1000 * payload.exp),
    email: payload.email,
    fullName: payload.name,
    companyName: companyItems.length > 0 ? companyItems[0] : "",
    phone: payload.phone_number,
    attrs: attributes,
  };
};

export { buildUserSession };
